import { Grid } from '@mui/material';
import { EmptyCoursesList } from './empty-courses-list';
import { ResourceCardSkeleton } from '@/components/shared/resource-card';
import type { EduplayCourse } from '@/data/eduplay/interfaces';
import { EduplayCourseCard } from '@/packages/eduplay/components/course-card';

const GRID_SIZE = { xs: 12, sm: 6, md: 4, lg: 3 };

interface EduplayCourseListProps {
  courses: EduplayCourse[];
  isLoading: boolean;
  isCompleted?: boolean;
}

export const EduplayCourseList = ({
  courses,
  isLoading,
  isCompleted,
}: EduplayCourseListProps) => {
  if (!isLoading && courses.length === 0) {
    return <EmptyCoursesList isCompleted={isCompleted} />;
  }

  return (
    <Grid container spacing={2}>
      {isLoading
        ? Array.from({ length: 4 }).map((_, index) => (
            <Grid size={GRID_SIZE} key={`skeleton-${index}`}>
              <ResourceCardSkeleton width="100%" />
            </Grid>
          ))
        : courses.map((course) => (
            <Grid size={GRID_SIZE} key={course.cursos_horarios_id}>
              <EduplayCourseCard course={course} />
            </Grid>
          ))}
    </Grid>
  );
};
